import * as React from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import axios from 'axios';
import { useState } from 'react';
import { useEffect } from 'react';
import { API_URL ,APP_URL} from '../../../Config';
import { Box, Typography } from '@mui/material';



export default function BasicTable(props) {
    const [ranking ,setranking]=useState("");
    const fetchranking = async()=>{

        return await axios.get(`${API_URL}/indexData.php?type=top&currency=${props.currency && props.currency}`, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }).then(res => {
           setranking(res.data);
          })
    }

    useEffect(()=>{
        fetchranking();
    },[])
    return (
        <TableContainer component={Paper} className='cadssd'>
            <Table aria-label="simple table">
                <TableHead>
                    <TableRow>
                        <TableCell>COLLECTION</TableCell>
                        <TableCell align="center">FLOOR PRICE</TableCell>
                        <TableCell align="center">VOLUME</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                     {ranking && ranking.map((row,idx)=>(
                                <TableRow>
                                <TableCell component="th" scope="row">
                                    <Box sx={{display:'flex', alignItems:'center', gap:'15px'}}>
                                    <Box>
                                        <Typography>
                                            {idx+1}
                                        </Typography>
                                    </Box>
                                    <Box>
                                        <img className='tab_pht' src={APP_URL +'/'+row.collection_logo} />
                                    </Box>
                                    <Box>
                                        <Typography variant='h6'>
                                          {row.collection}
                                        </Typography>
                                    </Box>
                                </Box>
                            
                            </TableCell>
                            <TableCell align="center">
                                <Box>
                                    <Typography variant='h6'>
                                        {row.floorPrice.substring(0,8)} {props.currency ?props.currency :""} 
                                    </Typography>
                                </Box>    
                            </TableCell>
                            <TableCell align="center">
                                <Box>
                                    <Typography variant='h6'>
                                    {row.amount.substring(0,8)} {props.currency ?props.currency :""} 
                                    </Typography>
                                </Box>
                            </TableCell>
                    </TableRow>

                     ))}
            
                </TableBody>
            </Table>
        </TableContainer>
    );
}